[
  {
    "id": 1,
    "image": "conversion_power.jpg",
    "title": "Conversion Power",
    "subtitle": "Rooted in Unmatched Travel Intent",
    "body": "Marriott Media is not another avenue. The differentiation is who the audience is and when they are reachable. Travelers are making real decisions on things to buy and they are more receptive to influence in these moments."
  },
  {
    "id": 2,
    "image": "travel_is_the_signal.png",
    "title": "Travel is the Signal",
    "subtitle": "Travelers aren't just on trips. They're valuable everywhere, all the time",
    "body": "Marriott Media meets people as travelers. And travelers are everywhere, all the time. The mindset extends into shopping, planning, self-improvement, indulgence, practicality, and discovery."
  },
  {
    "id": 3,
    "image": "first_party_data.jpg",
    "title": "First-Party Data (and Science)",
    "subtitle": "It's not the ad tech but knowing travelers psyche and activating that knowledge with integrity.",
    "body": "Marriott Bonvoy data is privacy-safe, opted-in, and deeply rich. The real value comes from matching that data to the right moment, mindset, and environment."
  }
]
